import { Flex, Paper, Stack, Text } from "@mantine/core";
import type { JSX } from "react";
import { UpdatedTime } from "@/sales-tools/pay-dashboard/components/UpdatedTime";

interface MetricCardProps {
    header: string | JSX.Element;
    body: string | JSX.Element;
    updatedTime: string;
}

export function MetricCard({ header, body, updatedTime }: MetricCardProps) {
    return (
        <Paper w="12.5rem" p=".875rem">
            <Stack gap="xxs">
                <Text fw={700}>{header}</Text>
                <Text size="xs">{body}</Text>
                <Flex c="dark.2">
                    <Flex fz="xxs">
                        <UpdatedTime updatedTime={updatedTime} />
                    </Flex>
                </Flex>
            </Stack>
        </Paper>
    );
}
